/**
 * MenuLoginButton component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled menu login button.
 */
const MenuLoginButton = styled.button<Props>`
  background: ${(props) =>
    props.focused ? `${Colors['modal']['button']['light']}` : 'none'};
  border: ${Colors['modal']['button']['light']} ${2 * Screen.widthRatio}px solid;
  border-radius: ${25 * Screen.widthRatio}px;
  color: ${(props) =>
    props.focused
      ? `${Colors['modal']['button']['text']}`
      : `${Colors['modal']['button']['light']}`};
  cursor: pointer;
  font-family: ${Fonts['regular']};
  font-size: ${24 * Screen.widthRatio}px;
  line-height: ${24 * Screen.widthRatio}px;
  padding: ${12 * Screen.widthRatio}px ${24 * Screen.widthRatio}px;
`;

export default MenuLoginButton;
